import React from "react";

import { Box, Typography, useTheme } from "@material-ui/core";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';


const Title: React.FC = () => {
    const theme = useTheme();
    return (
        <Box display="flex" alignItems="center">
            <InfoOutlinedIcon fontSize="large" style={{ marginRight: theme.spacing(1) }} />
            <Typography variant="h5" component="div">
                Retail zones
            </Typography>
        </Box>
    );
};

export default Title;
